import { shouldHideSaaSPricing } from "../utils";
import { isInvitedStaffUser } from "./staffName";

/**
 * Invited staff inherit the shop plan. Franchise tenants never pick Riverr
 * Free/Growth/Business. Sending them to /pricing then bouncing them to
 * /dashboard is a blank-page loop.
 */
export function shouldSkipSaaSPricingUi(user, enterprise) {
  return shouldHideSaaSPricing(enterprise) || isInvitedStaffUser(user);
}
